import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { removeEmojis } from '@app/core/utils';

@Component({
  selector: 'rk-notification-form-title-input',
  standalone: false,
  templateUrl: './notification-form-title-input.component.html',
  styleUrl: './notification-form-title-input.component.scss',
})
export class NotificationFormTitleInputComponent {
  @Input() titleControl!: FormControl<string>;

  removeEmojis(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    const noEmoji = removeEmojis(textarea.value);
    this.titleControl.setValue(noEmoji);
  }
}
